export default "__VITE_ASSET__znn4ypoF__"